var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('defaultImg',{staticClass:"banner",attrs:{"src":_vm.selectBanner()}}),_c('div',{staticClass:"content typeArea"},[_c('breadcrumb',{staticClass:"breadcrumb"})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }